import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <section className="feature-page about-premium">
      <div className="about-hero">
        <div className="about-hero-copy">
          <p className="about-kicker">Platform Story</p>
          <h1>About EcoPredict</h1>
          <div className="about-story-grid" aria-label="About EcoPredict details">
            <article className="about-story-card">
              <p>
                EcoPredict is your biodiversity intelligence cockpit that helps you spot insect-species risk early by turning live ecological signals into clear, decision-ready insights. From risk predictions and hotspot maps to smart search and live environmental headlines, EcoPredict is built for teams that need to move from data to action quickly. It combines GBIF records with NASA and OpenWeather signals to keep your monitoring workflow grounded in real-world conditions. Powered by a modern React and FastAPI architecture, EcoPredict delivers fast, interactive analytics for researchers, conservation teams, students, and policy stakeholders, and the built-in PDF chatbot helps you query ecological documents with source-grounded responses.
              </p>
            </article>
          </div>
        </div>

        <div className="about-hero-metrics" aria-label="Platform summary">
          <article className="about-hero-tile">
            <h3><span className="hero-tile-icon" aria-hidden="true">◌</span> Core Features</h3>
            <p>Predictions, Search, Analytics, Risk Maps, Live News</p>
          </article>
          <article className="about-hero-tile">
            <h3><span className="hero-tile-icon" aria-hidden="true">◍</span> Data Sources</h3>
            <p>GBIF, NASA, OpenWeather, RSS Environmental Feeds</p>
          </article>
          <article className="about-hero-tile">
            <h3><span className="hero-tile-icon" aria-hidden="true">◈</span> Stack</h3>
            <p>React + TypeScript + FastAPI + MongoDB</p>
          </article>
          <article className="about-hero-tile">
            <h3><span className="hero-tile-icon" aria-hidden="true">◎</span> Focus</h3>
            <p>Early Biodiversity Risk Detection and Faster Decisions</p>
          </article>
        </div>
      </div>

      <div className="panel">
        <h2>What You Can Do on This Website</h2>
        <ul>
          <li>Predict biodiversity risk by region, species, and coordinates in seconds.</li>
          <li>Track confidence shifts and trend momentum on a visual analytics dashboard.</li>
          <li>Pinpoint emerging pressure zones using global and regional hotspot views.</li>
          <li>Filter species records by geography and year to answer focused research questions.</li>
          <li>Stay current with a live biodiversity and climate news stream on the Home page.</li>
          <li>Ask questions against uploaded documents with the source-grounded PDF chatbot.</li>
        </ul>
      </div>

      <div className="panel">
        <h2>Who EcoPredict Is For</h2>
        <ul>
          <li>Conservation researchers prioritizing species-risk interventions.</li>
          <li>Environmental teams tracking habitat pressure and climate-linked change.</li>
          <li>Students and analysts learning biodiversity intelligence with live data.</li>
          <li>Policy and planning stakeholders who need clear, evidence-backed guidance.</li>
        </ul>
      </div>
    </section>
  );
};

export default AboutPage;
